(function() {
   "use strict";
    window.addEventListener("load", function() {
        var forms = document.getElementsByClassName("needs-validation");
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener("submit", function(event) {
                var hiddenRequiredFields = form.querySelectorAll("[required]");
                hiddenRequiredFields.forEach(function (field) {
                    var style = window.getComputedStyle(field);
                    if (style.display === "none") {
                        field.dataset.required = "true";
                        field.removeAttribute("required");
                    }
                });
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    form.classList.add("was-validated");
                    hiddenRequiredFields.forEach(function (field) {
                        if (field.dataset.required === "true") {
                            field.setAttribute("required", "required");
                            delete field.dataset.required;
                        }
                    });
                    return;
                }
                hiddenRequiredFields.forEach(function (field) {
                    if (field.dataset.required === "true") {
                        field.setAttribute("required", "required");
                        delete field.dataset.required;
                    }
                });
                form.classList.add("was-validated");
            }, false);
        });
    }, false);
})();

$("form").on("submit", function(){
    $(".form-control-chosen[required]").each(function(){
        if ( $( this ).val() === "") $( this ).next().removeClass("is-valid").addClass("is-invalid");
        else $( this ).next().removeClass("is-invalid").addClass("is-valid");
    });
});
